module.exports = "<div class=\"add-to-calendar-body\">\r\n  <a href=\"{{googleLink}}\" class=\"add-to-calendar-btn white\" target=\"_blank\">Add to Google</a>\r\n  <a href=\"{{outlook}}\" class=\"add-to-calendar-btn white\">Add to iCal/Outlook</a> \r\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/Components/desktop-add-to-calendar/desktop-add-to-calendar.component.html
// module id = ../../../../../src/app/Components/desktop-add-to-calendar/desktop-add-to-calendar.component.html
// module chunks = 1